//initial redux
import { put, call, takeEvery, fork, all, take } from "redux-saga/effects";
import * as router from "react-router-redux";
import { Children as ReactChildren } from "react";

function arrayLastItem(arr) {
	return arr[arr.length - 1];
}

class SortableColumn {
	constructor(th, name, dir) {
		this.th_Key = th.key;
		this.dataName = name;
		this.sortDir = dir;
	}
	th_Key = null;
	dataName = null;
	sortDir = 0; //0 = none; 1 = ASC; -1 = DESC
}

class TableIdentifier {
	constructor(_id, tableHeadBody, rowsPerPage) {
		this.id = _id;
		this.rowsPerPage = rowsPerPage;

		if (tableHeadBody.length === 2) {
			this.tableHead = tableHeadBody[0];
		}
		this.tableBody = arrayLastItem(tableHeadBody);

		if (this.tableHead) {
			const headChildren = Array.isArray(this.tableHead.props.children)
				? this.tableHead.props.children
				: [this.tableHead.props.children];

			for (let i = 0; i < headChildren.length; i++) {
				const tr = headChildren[i];
				if (!tr) {
					return null;
				}
				ReactChildren.forEach(tr.props.children, (th, index) => {
					if (th.props.sortable) {
						let dir = 0;
						if (th.props["default-sort"]) {
							if (this.hasDefaultSort) {
								throw new Error("Smart table cannot have multiple default sort columns");
							}
							if (th.props["default-sort"].toLowerCase() === "asc") {
								this.hasDefaultSort = true;
								dir = 1;
							} else if (th.props["default-sort"].toLowerCase() === "desc") {
								this.hasDefaultSort = true;
								dir = -1;
							}
						}

						this.sortableColumns.push(new SortableColumn(th, th.props.sortable, dir));
					}
				});
			}
		}
	}
	currentPageNumber = 0; //first page
	rowsPerPage = 0;
	rerenderthis = 0;
	tableHead = null;
	tableBody = null;
	sortableColumns = [];
	hasDefaultSort = false;
	id;
}

const initialState = {
	tables: {}
};

/////////
//types
export const types = {
	REGISTER_TABLE: "components/smarttable/REGISTER_TABLE",
	SORT_COLUMN: "components/smarttable/SORT_COLUMN",
	// UPDATE_DATA: "components/smarttable/UPDATE_DATA",
	UPDATE_TABLE: "components/smarttable/UPDATE_TABLE",
	CHANGE_PAGE: "components/smarttable/CHANGE_PAGE"
};

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.REGISTER_TABLE: {
				const exists = !!state.tables[action.payload.tableId];
				//if a table was persisted use that instead
				const table = exists
					? { ...state.tables[action.payload.tableId] }
					: new TableIdentifier(
							action.payload.tableId,
							action.payload.tableHeadBody,
							action.payload.rowsPerPage
					  );
				return {
					...state,
					tables: {
						...state.tables,
						[action.payload.tableId]: table
					}
				};
			}

			case types.SORT_COLUMN: {
				let table = Object.assign({}, state.tables[action.payload.tableId]);
				let sortableData = table.sortableColumns.find(x => x.th_Key === action.payload.thKey);
				if (sortableData) {
					table.sortableColumns.forEach(x => {
						x.sortDir = 0;
					});
					sortableData.sortDir = action.payload.direction;
					table.rerenderthis = table.rerenderthis + 1;
				}
				return {
					...state,
					tables: { ...state.tables, [action.payload.tableId]: table }
				};
			}

			case types.UPDATE_TABLE: {
				let table = state.tables[action.payload.tableId];
				return {
					...state,
					tables: { ...state.tables, [action.payload.tableId]: { ...table, ...action.payload.data } }
				};
			}

			case types.CHANGE_PAGE: {
				let table = Object.assign({}, state.tables[action.payload.tableId]);
				table.currentPageNumber += action.payload.pageIncrement;
				// make sure page number doesnt exit the range 0 - totalPages
				table.currentPageNumber = Math.max(0, Math.min(table.currentPageNumber, action.payload.totalPages - 1));
				table.rerenderthis = table.rerenderthis + 1;
				return {
					...state,
					tables: { ...state.tables, [action.payload.tableId]: table }
				};
			}

			default:
				return state;
		}
	}
};

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([]);
	}
};

////////
//actions
export const actions = {
	registerTable(tableId, tableHeadBody, rowsPerPage) {
		return {
			type: types.REGISTER_TABLE,
			payload: {
				tableId,
				tableHeadBody,
				rowsPerPage
			}
		};
	},

	setSortColumn(tableId, thKey, direction, rowsPerPage) {
		return {
			type: types.SORT_COLUMN,
			payload: {
				tableId,
				thKey,
				direction,
				rowsPerPage
			}
		};
	},

	changePage(tableId, pageIncrement, totalPages) {
		return {
			type: types.CHANGE_PAGE,
			payload: {
				tableId,
				pageIncrement,
				totalPages
			}
		};
	},

	updateTable(tableId, data) {
		return {
			type: types.UPDATE_TABLE,
			payload: {
				tableId,
				data
			}
		};
	},

	// updateData(tableId, data) {
	// 	return {
	// 		type: types.UPDATE_DATA,
	// 		payload: {
	// 			tableId,
	// 			data
	// 		}
	// 	};
	// },

	genericAction(type, data) {
		return {
			type,
			payload: data
		};
	}
};



// WEBPACK FOOTER //
// ./src/components/SmartTable/redux.js